import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import style from './page-layout.module.less';

const ActionsSection = ({ children = null, className = '' }) => <div className={classnames(className, style.actions)}>{children}</div>;

ActionsSection.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default ActionsSection;
